<template>
    <span v-html="svg" class="icon" ref="icon" @click.prevent="$emit('click', $event)">
    </span>
</template>
<script>
export default {
    props: ["icon", "height"],
    data() {
        return {
            svg: null
        };
    },
    mounted() {
        this.load();
        this.changeSize();
    },
    methods: {
        load() {
            const icon = require(`@/assets/img/icons/${this.icon}.svg`).default;
            this.svg = icon;
        },
        changeSize() {
            if (this.height) {
                this.$refs.icon.style.height = this.height + "px";
                this.$refs.icon.style.width = this.height + "px";
            }
        }
    },
    watch: {
        height() {
            this.changeSize();
        },
        icon() {
            this.load();
        }
    }
};
</script>
<style lang="scss">
.icon {
    display: inline-block;
    height: 20px;
    width: 20px;
    vertical-align: middle;
    font-size: inherit !important;

    svg {
        pointer-events: none;
    }
}
</style>
